import * as css from './SubscriptionRow.css';
import {useTranslation} from 'react-i18next';
import {pen, remove, blackDuplicate} from '../../../../assets/symbols/symbols/Symbols.css';
import useShow from '../../../../hooks/useShow';
import List from '../../../../component/list/List';
import {useRef} from 'react';
import useGlobalShow from '../../../../hooks/useGlobalShow';
import {setCurrentPlan} from '../../../../redux/subscription/subscriptionActions';
import {SubscriptionPlan} from '../../../../redux/subscription/subscription.type';

function SubscriptionOptions({plan}: {plan: SubscriptionPlan}) {
    const {t} = useTranslation('subscriptions');
    const {open, close, isOpen, showClass} = useShow();
    const createSubscriptionShow = useGlobalShow('isOpenCreateSubscription');
    const {planTid} = plan;
    const refList = useRef(null);

    const onDeletePlan = async() => {
        // TODO: Implement delete plan
        console.log('Delete plan', planTid);
    };

    const onDuplicate = () => {
        // TODO: Implement duplicate plan
        console.log('Duplicate plan', planTid);
    };
    
    const handleEdit = () => {     
        close();
        setCurrentPlan(planTid);
        createSubscriptionShow.open();
    };
    
    const optionsList = [
        {text: t('duplicate'), onClick: onDuplicate, icon: blackDuplicate, dataCyName: 'duplicate', disabled: true},
        {text: t('delete'), onClick: onDeletePlan, icon: remove, dataCyName: 'remove', disabled: true},
        {text: t('edit'), onClick: handleEdit, icon: pen, dataCyName: 'edit'}
    ];

    return (
        <css.options 
            onClick={(e) => {
                e.stopPropagation();
                isOpen ? close() : open();
            }} 
            data-cy="subscriptionOptions" 
            ref={refList}>
            {isOpen && refList.current && (
                <List 
                    left={refList.current.getBoundingClientRect().x + 'px'} 
                    list={optionsList} 
                    top={40} 
                    showClass={showClass} 
                    close={close}  
                    title={t('additionalActions')} 
                    fixedTop={refList.current.getBoundingClientRect().y}
                />
            )}
        </css.options>
    );
}

export default SubscriptionOptions;

